import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TariffPriceAnnual } from '../../../shared/models/tariff-price.annual';
import { TariffSummaryResults } from '../../../../assets/js/com/ts_api_client';
import { CUSTOMERMODE } from '../../enums/customerMode';
import { getInfoIText, KEY_FOR_CHARGE_FLEX_BONUS, TariffAdvisorService } from '../../services/tariff-advisor.service';
import { TARIFF_TEXT_KEYS } from '../../enums/tariffTextKeys';

const BONUS_TYPE = {
  NEW_CUSTOMER: 'Neukundenbonus',
  LOYALTY: 'Treuebonus',
  INSTANT: 'Sofortbonus'
};

interface Bonus {
  description: string,
  bonusType: string,
  bonusInfoI: string,
  baseNet: number,
  baseGross: number
}

@Component({
    selector: 'bdo-tariff-prices-overview',
    templateUrl: './tariff-prices-overview.component.html',
    styleUrls: ['./tariff-prices-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TariffPricesOverviewComponent implements OnChanges {
  @Input() prices: TariffPriceAnnual[];
  @Input() tariffData: TariffSummaryResults;
  @Input() withFrame: boolean = false;
  @Input() isContractEdit: boolean = false;
  public hasBonus: boolean;
  public CUSTOMERMODE = CUSTOMERMODE;
  public meterTooltip: string;
  public isHTNT: boolean = false;
  public isGewe: boolean;
  public hasPriceCap: boolean;
  public infoWorkprice: string = '';
  public infoBaseprice: string = '';
  public hasMissingNtConsumptionForHTNT: boolean = false;
  public KEY_FOR_CHARGE_FLEX_BONUS = KEY_FOR_CHARGE_FLEX_BONUS;
  public bonusToShow: Bonus[] = [];

  constructor(
    public tariffAdvisorService: TariffAdvisorService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.hasBonus = this.tariffData?.parts?.[0]?.contractPayments?.some(elem => elem.description.length > 0);
    this.isHTNT = this.tariffData?.parts?.[0]?.contractLevel?.filter(contractLevel => contractLevel.level === 4).length >= 2;
    this.hasMissingNtConsumptionForHTNT = this.isHTNT && this.tariffData.annualConsumption && !this.tariffData.annualConsumptionNt;
    this.meterTooltip = this.tariffAdvisorService.getMeterTooltip(this.tariffData?.customerType);
    this.isGewe = this.tariffData?.customerType === CUSTOMERMODE.GEWE;
    this.hasPriceCap = this.tariffData?.parts?.[0]?.priceCap ? true : false;

    this.bonusToShow = [];
    this.tariffData?.parts[0]?.contractPayments.forEach(bonus => {
      let bonusType: string = '';
      let cmsKeyBonus: string = '';

      if (bonus.description.includes(BONUS_TYPE.NEW_CUSTOMER)) {
        bonusType = BONUS_TYPE.NEW_CUSTOMER;
        cmsKeyBonus = TARIFF_TEXT_KEYS.InfoI_newCustomerBonus;

      } else if (bonus.description.includes(BONUS_TYPE.LOYALTY)) {
        bonusType = BONUS_TYPE.LOYALTY;
        cmsKeyBonus = TARIFF_TEXT_KEYS.InfoI_loyaltyBonus;

      } else if (bonus.description.includes(BONUS_TYPE.INSTANT)) {
        bonusType = BONUS_TYPE.INSTANT;
        cmsKeyBonus = TARIFF_TEXT_KEYS.InfoI_instantBonus;
      }

      if (cmsKeyBonus != '') {
        this.bonusToShow.push({
          description: bonus.description,
          bonusType: bonusType,
          bonusInfoI: getInfoIText(this.tariffData?.infois, cmsKeyBonus),
          baseGross: bonus.baseGross,
          baseNet: bonus.baseNet
        });
      }
    });

    this.infoWorkprice = getInfoIText(this.tariffData?.infois, TARIFF_TEXT_KEYS.InfoI_workprice);
    this.infoBaseprice = getInfoIText(this.tariffData?.infois, TARIFF_TEXT_KEYS.InfoI_baseprice);
  }

  getChargeFlexBonusData(index: number) {
    return this.tariffData?.parts?.[index]?.contractPayments.find(item =>
      item.description?.includes(KEY_FOR_CHARGE_FLEX_BONUS)
    );
  }

}
